import { UserPlus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../../api/adminDataProvider';
import { CustomBulkAction } from '../../Moonstar/CustomBulkAction';

export const BulkAddRoleUsers = (props: { roleId: number }) => {
  const dataProvider = useDataProvider<AdminDataProvider>();

  return (
    <CustomBulkAction
      mutationFn={(userIds) =>
        dataProvider.addRoleUsers({
          data: userIds.map((userId) => ({
            roleId: props.roleId,
            userId,
          })),
        })
      }
      label="ra.action.add"
      buttonIcon={<UserPlus />}
      successMessage="moonstar.roleUsers.add.successMessage"
    />
  );
};
